module.exports = __webpack_public_path__ + "static/banner-424beed01a32a857bdc5701e98116d4f.png";